import { ChangeDetectionStrategy, ChangeDetectorRef, Component, viewChild, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { isArray } from 'lodash';
import { I18nService } from '../../../@core/services/i18n/i18n.service';
import { PhxSelect } from "../../../shared/components/phx-select/phx-select.component";
import { LocaleRegionNamePipe } from '../../../shared/pipes/locale-region-name.pipe';
@Component({
  selector: 'app-formly-phx-select',
  templateUrl: './formly-phx-select.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PhxSelect,
    TranslatePipe,
    FormlyModule,
    ReactiveFormsModule,
    LocaleRegionNamePipe,
  ]
})
export class FormlyPhxSelectComponent extends FieldType<FieldTypeConfig> {
  selectComponent = viewChild<PhxSelect<any>>("selectComponent");
  itemTemplate = viewChild<any>("itemTemplate");
  localeTemplate = viewChild<any>("localeTemplate");
  allOptions: any[] = [];

  constructor(
    private i18n: I18nService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    let needChangeDetection = false;
    if (this.props.options && isArray(this.props.options)) {
      for (let i = 0; i < this.props.options.length; i++) {
        const option = this.props.options[i];
        if (option.translate && option.label) {
          option.label = this.i18n.translate(option.label);
          needChangeDetection = true;
        }
        this.allOptions.push(option);
      }
    }
    if (needChangeDetection) {
      this.cdRef.markForCheck();
    }
  }

  onFilter(term: any) {
    if (this.allOptions && this.allOptions.length > 0) {
      if (!term || term.length == 0)
        this.props.options = this.allOptions;
      else
        this.props.options = this.allOptions.filter(option => option.label.toLowerCase().indexOf(term.toLowerCase()) > -1);
    }

    this.selectComponent().loading.set(false);
  }

  getItemTemplate() {
    if (this.props.useLocaleTemplate) {
      return this.localeTemplate();
    }
    return this.itemTemplate();
  }
}
